var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoRulesFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M465.572 427H303.429C285.518 427 271 442.894 271 462.501V480.25C271 490.053 278.259 498 287.214 498H481.786C490.741 498 498 490.053 498 480.25V462.501C498.001 442.894 483.482 427 465.572 427Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.332 17.4773C279.694 4.83897 259.221 4.84478 246.583 17.4715L152.209 111.84C139.57 124.479 139.57 144.963 152.209 157.595C164.847 170.234 185.317 170.231 197.958 157.601L292.332 63.2323C304.971 50.594 304.971 30.1098 292.332 17.4773Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M475.33 200.475C462.692 187.847 442.218 187.843 429.581 200.481L335.217 294.85C322.579 307.482 322.579 327.967 335.217 340.605C347.858 353.236 368.33 353.236 380.966 340.599L475.33 246.23C487.969 233.597 487.969 213.113 475.33 200.475Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M313.78 87.5382L222.272 179.041L313.77 270.542L405.276 179.031L313.78 87.5382Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.834 213.358L24.3695 399.822C5.4963 418.695 5.4963 449.538 24.3695 468.41L24.477 468.518C43.9886 487.806 74.6505 486.927 92.958 468.41L279.467 281.993L210.834 213.358Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRulesFill);
export default __webpack_public_path__ + "static/media/ico_rules_fill.eb6c740632334425592f83232221da5c.svg";
export { ForwardRef as ReactComponent };